export default __webpack_public_path__ + "static/media/logoPlayContrataMais2.05c15c24.png";